export default __webpack_public_path__ + "static/opt-grad-right-141fefe6af0f34f9818fffa2b448dad3.svg";